import { Link, useLocation } from "wouter";
import { Logo } from "./Logo";
import { useEffect, useState } from "react";
import { getSession, logout } from "../lib/api";

export function Shell({ children }: { children: React.ReactNode }) {
  const [session, setSession] = useState(getSession());
  const [, navigate] = useLocation();
  useEffect(() => {
    const h = () => setSession(getSession());
    window.addEventListener("sportal:session", h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener("sportal:session", h);
      window.removeEventListener("storage", h);
    };
  }, []);

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100 flex flex-col">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-neutral-950/70 border-b border-neutral-900">
        <div className="mx-auto max-w-6xl px-6 h-16 flex items-center justify-between">
          <Link href="/" className="inline-flex items-center" aria-label="Sportal home">
            <Logo size={28} withWordmark />
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-sm text-neutral-400">
            <Link href="/clubs" className="hover:text-neutral-0 transition-colors">Book a tee time</Link>
            <Link href="/me/bookings" className="hover:text-neutral-0 transition-colors">My bookings</Link>
          </nav>
          <div className="flex items-center gap-3">
            {session ? (
              <>
                <span className="hidden sm:inline text-sm text-neutral-500">{session.user?.email}</span>
                <button
                  onClick={() => { logout(); navigate("/"); }}
                  className="text-sm text-neutral-400 hover:text-neutral-0 transition-colors"
                >
                  Sign out
                </button>
              </>
            ) : (
              <Link
                href="/login"
                className="text-sm text-neutral-400 hover:text-neutral-0 transition-colors"
              >
                Sign in
              </Link>
            )}
            <Link
              href="/clubs"
              className="inline-flex items-center rounded-full bg-accent-500 text-neutral-950 px-4 py-1.5 text-sm font-medium hover:bg-accent-400 transition-colors"
            >
              Book now
            </Link>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-neutral-900 py-10 mt-20">
        <div className="mx-auto max-w-6xl px-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-neutral-500">
          <div className="flex items-center gap-2">
            <Logo size={20} />
            <span>© {new Date().getFullYear()} Sportal</span>
          </div>
          <div className="flex items-center gap-6">
            <a href="mailto:hello@sportalapp.com" className="hover:text-neutral-0 transition-colors">hello@sportalapp.com</a>
            <a href="https://admin.sportalapp.com" className="hover:text-neutral-0 transition-colors">Club admin</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
